import { render, staticRenderFns } from "./TheWell.vue?vue&type=template&id=83e8e5ee"
import script from "./TheWell.vue?vue&type=script&lang=ts"
export * from "./TheWell.vue?vue&type=script&lang=ts"
import style0 from "./TheWell.vue?vue&type=style&index=0&id=83e8e5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports